<template>
    <v-container class="report-body ma-0 pb-4">
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" md="4">
                        Relatório de Pontos de Venda
                    </v-col>
                    <v-col cols="12" md="4"></v-col>
                    <v-col cols="12" md="4" class="text-right">
                        <v-tooltip bottom color="primary">
                            <template v-slot:activator="{ on }" >
                                <v-btn
                                    v-on="on"
                                    color="white"
                                    :loading="awaitingReportDownload"
                                    @click="exportReport()"
                                >
                                    <v-icon color="primary">mdi-download</v-icon>
                                </v-btn>
                            </template>
                            Baixar Relatório em XLS
                        </v-tooltip>
                        <v-btn
                            width="50%"
                            color="#f2c037"
                            class="filter-btn"
                            @click="filterDrawer = !filterDrawer"
                        >
                            <v-icon class="mr-2" small>mdi-filter-outline</v-icon>
                            Filtros {{filteredResult ? '(ativo)' : ''}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <point-of-sale-report-table
                    ref="pointOfSaleReportTable"
                />
            </v-card-text>
        </v-card>
        <filter-drawer
            :show-drawer="filterDrawer"
            @clear-filter="clearFilter()"
            @apply-filter="applyFilter()"
        >
            <template v-slot:form>
                <v-form>
                    <p class="mb-2 filter-label">Ponto de Venda</p>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="filterPointOfSaleId"
                                outlined
                                hide-details
                                label="Código"
                            />
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-text-field
                                v-model="filterPointOfSaleName"
                                outlined
                                hide-details
                                label="Nome"
                            />
                        </v-col>
                    </v-row>
                    <p class="mt-6 mb-2 filter-label">Reservas Feitas Em</p>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterBookingStartDate"
                                        label="De"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="bookingStartDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-menu
                                :close-on-content-click="true"
                                transition="scale-transition"
                                offset-y
                                left
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="filterBookingUntilDate"
                                        label="Até"
                                        append-icon="mdi-calendar"
                                        outlined
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="bookingUntilDateCalendar"
                                    no-title
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </template>
        </filter-drawer>
    </v-container>
</template>

<script>
import FilterDrawer from "../../components/Reports/FilterDrawer.vue";
import PointOfSaleReportTable from "../../components/Reports/Tables/PointOfSaleReportTable.vue";
import {downloadFile, getFileNameWithSalt} from "../../services/DownloadFileService";

export default {
    name: "PointsOfSaleReport",

    components: {
        PointOfSaleReportTable,
        FilterDrawer,
    },

    data: () => ({
        filter: {},
        filterDrawer: '',
        filterPointOfSaleId: '',
        filterPointOfSaleName: '',
        filterBookingStartDate: '',
        filterBookingUntilDate: '',
        bookingStartDateCalendar: '',
        bookingUntilDateCalendar: '',
        filteredResult: false,
        awaitingReportDownload: false,
    }),

    methods: {
        formatDate (dateCalendar) {
            if (!dateCalendar) return null

            const [year, month, day] = dateCalendar.split('-')
            return `${day}/${month}/${year}`
        },

        formatDateToFilter(date) {
            let formattedDate = '';
            if (date) {
                let dateSplit = date.split('/');
                if (dateSplit[2] && dateSplit[1]) {
                    formattedDate = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`
                    return formattedDate;
                }
            }
            return date;
        },

        clearFilter() {
            this.$router.replace({query: null});
            window.location.reload();
        },

        setFilter() {
            this.filter = {
                'pointOfSaleId': this.filterPointOfSaleId ?? '',
                'pointOfSaleName': this.filterPointOfSaleName ?? '',
                'bookingStartDate': this.formatDateToFilter(this.filterBookingStartDate) ?? '',
                'bookingUntilDate': this.formatDateToFilter(this.filterBookingUntilDate) ?? '',
            };
            this.filteredResult = this.resultIsFiltered(this.filter);
            this.$refs.pointOfSaleReportTable.setFilter(this.filter);
        },

        applyFilter() {
            this.setFilter();
            this.$refs.pointOfSaleReportTable.getReportData(this.filter);
            this.filterDrawer = !this.filterDrawer;
        },

        resultIsFiltered(filter) {
            for (let filterKey in filter) {
                if (filter[filterKey]) {
                    return true;
                }
            }
            return false;
        },

        getFilterFromUrlQuery() {
            if(Object.keys(this.$route.query).length) {
                const {
                    pointOfSaleId,
                    pointOfSaleName,
                    bookingStartDate,
                    bookingUntilDate,
                    startDate,
                    finalDate,
                } = this.$route.query;
                if (pointOfSaleId) {
                    this.filterPointOfSaleId = pointOfSaleId;
                }
                if (pointOfSaleName) {
                    this.filterPointOfSaleName = pointOfSaleName;
                }
                if (bookingStartDate || startDate) {
                    this.filterBookingStartDate = bookingStartDate ?? startDate;
                }
                if (bookingUntilDate || finalDate) {
                    this.filterBookingUntilDate = bookingUntilDate ?? finalDate;
                }
            }
            this.setFilter();
        },

        async exportReport () {
            try {
                this.awaitingReportDownload = true;
                const response = await axios.get('/api/reports/point-of-sale/export', { params: this.getQueryParams(), responseType: 'blob' });
                downloadFile(response.data, getFileNameWithSalt('relatorio_pontos_de_venda_partner_hub'), 'xls');
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao baixar o relatório!', 'error');
            } finally {
                this.awaitingReportDownload = false;
            }
        },

        getQueryParams () {
            return {
                sortBy: this.getParamFromQuery('sortBy'),
                sortDesc: this.getParamFromQuery('sortDesc'),
                limit: this.getParamFromQuery('limit'),
                pointOfSaleId: this.filter.pointOfSaleId,
                pointOfSaleName: this.filter.pointOfSaleName,
                bookingStartDate: this.filter.bookingStartDate,
                bookingUntilDate: this.filter.bookingUntilDate,
            }
        },

        getParamFromQuery (paramName) {
            const param =  this.$route.query[paramName];
            return Array.isArray(param) ? param[0] : param;
        }
    },

    mounted() {
        this.getFilterFromUrlQuery();
    },

    watch: {
        bookingStartDateCalendar: function(date) {
            this.filterBookingStartDate = this.formatDate(date);
        },
        bookingUntilDateCalendar: function(date) {
            this.filterBookingUntilDate = this.formatDate(date);
        },
    },
}
</script>

<style scoped>
.report-body {
    background: #f0f0f0;
    max-width: 100%;
    min-height: 100vh;
}

.filter-btn {
    color: #FFF;
}

.filter-label {
    font-size: 18px;
    color: #333;
}
</style>
